export interface StripeProduct {
  priceId: string;
  name: string;
  description: string;
  mode: 'subscription' | 'payment';
}

export const PRODUCTS: StripeProduct[] = [
  {
    priceId: 'price_1Rm79jCEgfoZyV3UFH0J8X00', // 本番年額プラン
    name: 'SprintAnalysisアプリ（年額プラン）',
    description: 'スプリント分析アプリの年額サブスクリプション - 初回3ヶ月無料',
    mode: 'subscription'
  }
];